import { Box, Typography } from "@mui/material";
import { ButtonUI } from "../../../ui";
import { useTranslation } from "react-i18next";

interface Props {
  selectedCount: number;
  onPublish: () => void;
  onIssueQr: () => void;
  onExport: () => void;
  onDelete: () => void;
  onClear: () => void;
}

const BulkActionsBar = ({
  selectedCount,
  onPublish,
  onIssueQr,
  onExport,
  onDelete,
  onClear,
}: Props) => {
  const { t } = useTranslation();

  if (selectedCount === 0) return null;

  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 10,
        display: "flex",
        alignItems: "center",
        gap: "12px",
        padding: "12px 16px",
        marginBottom: "16px",
        backgroundColor: "#F5F5F5",
        borderRadius: "12px",
        flexWrap: "wrap",
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600, marginRight: "8px" }}>
        {t("bulk_selected", { count: selectedCount })}
      </Typography>
      <ButtonUI type="outline" text={t("publish")} onClick={onPublish} />
      <ButtonUI type="outline" text={t("bulk_issue_qr")} onClick={onIssueQr} />
      <ButtonUI type="outline" text={t("bulk_export")} onClick={onExport} />
      <ButtonUI type="outline" text={t("delete")} onClick={onDelete} />
      <ButtonUI type="outline" text={t("cancel")} onClick={onClear} hasBorder={false} />
    </Box>
  );
};

export default BulkActionsBar;
